import React, { Component } from "react";
import {
  GET,
  loading,
  Navbar,
  Select,
  toFixed,
} from "../../components/CustomComponent.js";
import "bootstrap/dist/css/bootstrap.min.css";

const pad = (n) => String(n).padStart(2, "0");
const fmtDay = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
const fmtMonth = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}`;

// Default range: last 30 days for day, last 12 months for month
const DefaultRange = (period_type) => {
  const to = new Date();
  if (period_type === "month") {
    const from = new Date(to.getFullYear(), to.getMonth() - 12, 1);
    return { filter_from: fmtMonth(from), filter_to: fmtMonth(to) };
  }
  const from = new Date(to.getFullYear(), to.getMonth(), to.getDate() - 30);
  return { filter_from: fmtDay(from), filter_to: fmtDay(to) };
};

// alert_level = ระดับแจ้งเตือน Telegram สูงสุดที่ส่งไปแล้วของวันนั้น (0 / 80 / 90 / 100)
const alertBadge = (level) => {
  const n = Number(level) || 0;
  if (n >= 100) return { cls: "bg-danger", text: "100% reached" };
  if (n >= 90) return { cls: "bg-danger", text: "90% alerted" };
  if (n >= 80) return { cls: "bg-warning text-dark", text: "80% alerted" };
  return null;
};

const percentColor = (p) => (p >= 90 ? "bg-danger" : p >= 80 ? "bg-warning" : "bg-success");

export default class GatewayGmvUsage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filter_period_type: "day",
      ...DefaultRange("day"),
      filter_broker: "",
      filter_gateway: "",
      data_broker: [],
      data_gateway: [],
      data: [],
      loaded: false,
    };
  }

  async componentDidMount() {
    loading(false);
    await Promise.all([this.GetMaster(), this.Get()]);
  }

  GetMaster = async () => {
    const [result_broker, result_gateway] = await Promise.all([
      GET("v1/admin/brokers/options", { page_size: 1000000, page: 0, data_search: "" }),
      GET("gateway-rules/list", { page_size: 100000, page: 0, data_search: "" }),
    ]);
    this.setState({
      data_broker: result_broker?.status
        ? result_broker.data.map((e) => ({ value: e.uid, label: e.name_en }))
        : [],
      // the report filters by gateway_name, so the label is the value
      data_gateway: result_gateway?.status
        ? result_gateway.data.map((e) => ({ value: e.gateway_name, label: e.gateway_name }))
        : [],
    });
  };

  Get = async () => {
    const { filter_period_type, filter_from, filter_to, filter_broker, filter_gateway } = this.state;
    loading(true);
    const result = await GET("v1/admin/brokers/gateway-usages", {
      period_type: filter_period_type,
      from: filter_from,
      to: filter_to,
      broker_uid: filter_broker,
      gateway: filter_gateway,
    });
    this.setState({ data: result?.status ? result.data || [] : [], loaded: true });
    loading(false);
  };

  render() {
    const {
      filter_period_type,
      filter_from,
      filter_to,
      filter_broker,
      filter_gateway,
      data_broker,
      data_gateway,
      data,
      loaded,
    } = this.state;
    const input_type = filter_period_type === "month" ? "month" : "date";
    const money = (v) => toFixed(Number(v) || 0, 2);

    return (
      <div className="w-100 min-vh-100 premium-report pr-scope pu-scope">
        <Navbar />
        <div className="body p-3 mt-3">
          <div className="ar-hero mb-4">
            <div className="ar-hero-head">
              <div>
                <div className="ar-eyebrow mb-1">Reports</div>
                <div className="ar-title">GMV Usage</div>
                <div className="ar-subtitle">Track gateway GMV usage against limits by period, broker and gateway.</div>
              </div>
            </div>
          <div className="ar-toolbar ar-filter mt-3">
<div className="ar-filter-head">
<span className="ar-toolbar-label"><span className="icon me-2">{"\uf0b0"}</span>Filter</span>
</div>
<div className="ar-filter-row">
<div className="ar-filter-field">
<span className="ar-filter-label">Period Type</span>
<Select
                className="form-control"
                options={[
                  { value: "day", label: "Day" },
                  { value: "month", label: "Month" },
                ]}
                value={filter_period_type}
                onChange={(v) => {
                  this.setState({ filter_period_type: v, ...DefaultRange(v) }, () => this.Get());
                }}
              />
</div>
<div className="ar-filter-field">
<span className="ar-filter-label">From</span>
<input
                type={input_type}
                className="form-control"
                value={filter_from}
                onChange={(e) => this.setState({ filter_from: e.target.value })}
              />
</div>
<div className="ar-filter-field">
<span className="ar-filter-label">To</span>
<input
                type={input_type}
                className="form-control"
                value={filter_to}
                onChange={(e) => this.setState({ filter_to: e.target.value })}
              />
</div>
<div className="ar-filter-field">
<span className="ar-filter-label">Broker</span>
<Select
                className="form-control"
                options={[{ value: "", label: "All Broker" }, ...data_broker]}
                value={filter_broker}
                onChange={(v) => this.setState({ filter_broker: v })}
              />
</div>
<div className="ar-filter-field">
<span className="ar-filter-label">Gateway</span>
<Select
                className="form-control"
                options={[{ value: "", label: "All Gateway" }, ...data_gateway]}
                value={filter_gateway}
                onChange={(v) => this.setState({ filter_gateway: v })}
              />
</div>
<div className="ar-toolbar-actions">
                <button className="ar-btn-gold w-100 justify-content-center" onClick={() => this.Get()}>
                  Search
                </button>
              </div>
</div>
</div>
          </div>

          <div className="ar-table-card">
            <div className="ar-table-head">
              <div>
                <div className="ar-table-title">
                  <span className="icon me-2 pu-title-icon">{"\uf080"}</span>
                  GMV Usage
                </div>
                <div className="ar-table-caption">{data.length} row{data.length === 1 ? "" : "s"}</div>
              </div>
            </div>
          <div className="table-responsive" style={{ minHeight: 200 }}>
            <table className="table table-hover ar-table pu-table pu-table-compact">
              <thead>
                <tr>
                  <td>Period</td>
                  <td>Broker</td>
                  <td>Gateway</td>
                  <td>Company</td>
                  <td>Business Type</td>
                  <td className="text-end">Used (THB)</td>
                  <td className="text-end">Limit</td>
                  <td style={{ minWidth: 140 }}>%</td>
                  <td className="text-end">Qty</td>
                  <td>Alert</td>
                </tr>
              </thead>
              <tbody>
                {data.map((row, i) => {
                  const percent = row.percent === null || row.percent === undefined ? null : Number(row.percent);
                  return (
                    <tr key={`${row.period_key}-${row.broker_gateway_uid}-${i}`}>
                      <td>{row.period_key}</td>
                      <td>{row.broker_name}</td>
                      <td>{row.gateway_name}</td>
                      <td>{row.company_name || "-"}</td>
                      <td>{row.business_type || "-"}</td>
                      <td className="text-end">{money(row.total_amount)}</td>
                      <td className="text-end">{row.limit === null || row.limit === undefined ? "Unlimited" : money(row.limit)}</td>
                      <td>
                        {percent === null ? (
                          "-"
                        ) : (
                          <div>
                            <small>{percent.toFixed(2)}%</small>
                            <div className="progress" style={{ height: 6 }}>
                              <div
                                className={`progress-bar ${percentColor(percent)}`}
                                role="progressbar"
                                style={{ width: `${Math.min(100, percent)}%` }}
                                aria-valuenow={Math.min(100, percent)}
                                aria-valuemin={0}
                                aria-valuemax={100}
                              />
                            </div>
                          </div>
                        )}
                      </td>
                      <td className="text-end">{Number(row.qty || 0).toLocaleString()}</td>
                      <td>
                        {alertBadge(row.alert_level) ? (
                          <span className={`badge ${alertBadge(row.alert_level).cls}`}>{alertBadge(row.alert_level).text}</span>
                        ) : (
                          "-"
                        )}
                      </td>
                    </tr>
                  );
                })}
                {loaded && data.length === 0 && (
                  <tr>
                    <td colSpan={10} className="text-center py-5 text-secondary">
                      No data
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          </div>
        </div>
      </div>
    );
  }
}
